export default "__VITE_ASSET__BIn4nxkX__"